import React from "react"
import type { CustomFieldNumber } from "@love-irish/types"
import { Badge } from "@love-irish/ui-components"

const NumberField = ({ field }: { field: CustomFieldNumber }) => {
  return (
    <Badge variant="outline">
      <strong className="mr-1">{field.label}:</strong> {field.value}
    </Badge>
  )
}

export default NumberField
